import "./App.scss";
import MainRouter from "./_routers/Router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SearchMenu from "./features/searchmenu/SearchMenu";

function App() {
  return (
    <div>
      <SearchMenu />
      <ToastContainer />
      <MainRouter />
    </div>
  );
}

export default App;
